export const familiesMenuItem = {
  label: 'Families',
  href: 'https://family.rockalingua.com/',
  plausibleEvent: 'button_click',
  plausibleProps: {
    buttonName: 'families',
    location: 'header',
  },
};
